import React, { useContext} from 'react'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext';

const Clock = ({seconds}) => {
    const {clockString, pomodoroState, breakMode } = useContext(ClockContext)

    return (
        <div className='timer-clock'>
            <p className={`state ${breakMode ? 'break-mode' : ''}`}>{pomodoroState}</p>
            <p className={`clock ${breakMode ? 'break-mode' : ''}`}>{clockString}</p>
        </div>
    )
}

export default Clock